import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subscription, map, startWith, of } from 'rxjs';
import { JobTypes } from 'src/app/shared/models/job-types.model';
import { JobTypesService } from 'src/app/core/services/data/job-types.service';
import { FormControl } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { TradeSearchService } from 'src/app/core/services/http/trade-mgmt/trade-search.service';
import { PropertyService } from 'src/app/core/services/http/agency-mgmt/property.service';
import { SearchTradesByNameAndEmailResult } from '../../models/search-trades-by-name-and-email-result.model';
import { SearchPropertyByNameAndAddressResult } from '../../models/search-property-by-name-and-address-result.model';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { JobTypeEnum } from '../../models/Enums';
import { AdvancedSearchQueryModel } from '../../models/advanced-search-request.model';
import { AdvancedSeachFilteredJobsResult } from 'src/app/job/models/dashboard/advanced-search-filtered-jobs-result.model';
import { JobSearchService } from 'src/app/core/services/http/maintenance/job-search.service';
import { AdvancedSearch } from '../../models/advanced-search.model';
import { DateAdapter } from '@angular/material/core';
import { SelectedTeamResult } from 'src/app/job/components/job-dashboard/team-selection/selected-team-result.model';
@Component({
  selector: 'app-advanced-search',
  templateUrl: './advanced-search.component.html',
  styleUrls: ['./advanced-search.component.scss'],
})
export class AdvancedSearchComponent implements OnInit, OnDestroy {
  searchModel = AdvancedSearch.getInstance();
  public separatorKeysCodes: number[] = [ENTER, COMMA];
  public serviceTypes: JobTypes[] = [];
  public serviceTypes$: Observable<JobTypes[] | null>;
  public ServiceTypeControl = new FormControl();
  public subscription: Subscription;
  public TradeNameFragment: string;
  public ServiceTypeFragment: string;
  public PropertyFragment: string;
  public tradees: SearchTradesByNameAndEmailResult[] = null;
  public tradees$: Observable<SearchTradesByNameAndEmailResult[]> = null;
  public tradeeControl = new FormControl();
  public propertyControl = new FormControl();
  public properties: SearchPropertyByNameAndAddressResult[] = null;
  public properties$: Observable<SearchPropertyByNameAndAddressResult[]> = null;
  private searchTimeout: any;
  public requestDto: AdvancedSearchQueryModel = <AdvancedSearchQueryModel>{};
  public jobList: AdvancedSeachFilteredJobsResult[] = null;
  public isApply: boolean = false;
  public includeDeactivatedProperties: boolean = false;
  public teamUsers: SelectedTeamResult[] = null;
  public snoozedJobsCheckboxVisible: boolean = false;
  public isSnoozedJob: boolean = false;
  ORGANIZATION_VIEW_ID = 'ORGANIZATION_VIEW_ID';

  @Output() requestDtoEvent = new EventEmitter<
    AdvancedSeachFilteredJobsResult[]
  >();
  @ViewChild('serviceTypeInput') serviceTypeInput: ElementRef<HTMLInputElement>;
  @ViewChild('tradeeInput') tradeeInput: ElementRef<HTMLInputElement>;
  @ViewChild('propertyInput') propertyInput: ElementRef<HTMLInputElement>;
  @ViewChild('snoozedJobsInput') snoozedJobsInput: ElementRef<HTMLInputElement>;
  //@ViewChild('deactivatedPropertyInput') deactivatedPropertyInput: ElementRef<HTMLInputElement>;

  constructor(
    private router: Router,
    private jobTypeSvc: JobTypesService,
    private tradeSearchService: TradeSearchService,
    private propertyService: PropertyService,
    private jobSearchService: JobSearchService,
    private dateAdapter: DateAdapter<Date>
  ) {
    this.dateAdapter.setLocale('en-GB'); //dd/MM/yyyy
  }

  public loadingTradees: boolean = false;
  public loadingServiceType: boolean = false;
  public loadingProperties: boolean = false;

  ngOnInit(): void {
    this.getServiceTypes();
    if (!this.searchModel.isApply) {
      this.initialLoadJobStatus();
    }

    this.serviceTypes$ = this.ServiceTypeControl.valueChanges.pipe(
      startWith(''),
      map((value) => this.filterServiceTypes(value))
    );
    this.setPostedStartEndDate();
    this.getTeamUsers();
    this.updateSnoozedJobsCheckboxVisibility();
  }

  private getServiceTypes() {
    this.subscription = this.jobTypeSvc.getJopTypes().subscribe({
      next: (response) => {
        this.serviceTypes = response;
        this.loadingServiceType = false;
      },
    });
  }

  SetDefaultValues(deactivatedPropertyInput,snoozedJobsInput) {
    this.searchModel.statuses = [];
    this.searchModel.selectedStatus = [];
    this.searchModel.selectedJobType = [];
    this.searchModel.tradeesChips = [];
    this.searchModel.serviceTypesChips = [];
    this.searchModel.propertyChips = [];
    this.searchModel.selectedUrgency = this.searchModel.urgencyTypes[0];
    this.searchModel.selectedJobIdentification = null;
    this.searchModel.selectedJobType.push(this.searchModel.jobTypes[1]);
    this.searchModel.statuses = this.searchModel.openJobStatus.concat(
      this.searchModel.closedJobStatus
    );
    this.searchModel.statuses.sort((f1, f2) => f1.text.length - f2.text.length);
    this.setWorkOrderOption();
    this.searchModel.statuses.unshift({ id: null, text: 'Any' });
    this.searchModel.selectedStatus.push(this.searchModel.statuses[0]);
    this.setPostedStartEndDate();
    this.searchModel.deadLine_Start = '';
    this.searchModel.deadLine_end = '';
    this.TradeNameFragment = '';
    this.tradeeInput.nativeElement.value = '';
    this.ServiceTypeFragment = '';
    this.serviceTypeInput.nativeElement.value = '';
    this.PropertyFragment = '';
    this.propertyInput.nativeElement.value = '';
 //this.deactivatedPropertyInput.nativeElement.checked = false;
    deactivatedPropertyInput.checked = false;
    this.updateSnoozedJobsCheckboxVisibility();
    this.isSnoozedJob = false;
    this.searchModel.isSnoozedJob = false;
    this.includeDeactivatedProperties = false;
    this.searchModel.selectedTeamUsers = [];

  }

  private filterServiceTypes(value: string): JobTypes[] {
    const filterValue = value.toLowerCase();
    var filteredServiceType = this.serviceTypes.filter((serviceType) =>
      serviceType.primaryJobType.name.toLowerCase().includes(filterValue)
    );
    if (filteredServiceType != null && filteredServiceType.length > 0) {
      this.loadingServiceType = true;
    } else {
      this.loadingServiceType = false;
    }
    return filteredServiceType;
  }

  public OnTradeNameFragmentChanged(event: any) {
    this.TradeNameFragment = event!.value;
    clearTimeout(this.searchTimeout);
    this.tradees = null;
    var $this = this;
    $this.TradeSearch();
  }

  public OnServiceTypeFragmentChanged(event: any) {
    this.serviceTypes$ = of(this.filterServiceTypes(event!.value));
  }

  public OnPropertyFragmentChanged(event: any) {
    this.PropertyFragment = event!.value;
    clearTimeout(this.searchTimeout);
    this.properties = null;
    var $this = this;
    $this.PropertySearch();
  }

  private TradeSearch() {
    this.tradees = null;
    if (this.TradeNameFragment && this.TradeNameFragment.length >= 3) {
      this.loadingTradees = true;
      this.tradeSearchService
        .searchTradesByNameAndEmail(this.TradeNameFragment)
        .subscribe({
          next: (res) => {
            this.tradees = res;
            this.tradees$ = of(res);
            this.loadingTradees = false;
          },
          error: () => {
            this.tradees = null;
            this.tradees$ = null;
            this.loadingTradees = false;
          },
        });
    }
  }

  private PropertySearch() {
    this.properties = null;
    if (this.PropertyFragment && this.PropertyFragment.length >= 3) {
      this.loadingProperties = true;
      this.propertyService
        .advancedSearchProperty(this.PropertyFragment, this.includeDeactivatedProperties)
        .subscribe({
          next: (res) => {
            this.properties = res;
            this.properties$ = of(res);
            this.loadingProperties = false;
          },
          error: () => {
            this.properties = null;
            this.properties$ = null;
            this.loadingProperties = false;
          },
        });
    }
  }

  public includeDeactivatedPropertiesCheck() {
    this.includeDeactivatedProperties = !this.includeDeactivatedProperties;
  }

  public snoozedJobsCheck() {
    this.isSnoozedJob = !this.isSnoozedJob;
    this.searchModel.isSnoozedJob = this.isSnoozedJob ;
  }

  public jobDashBoard() {
    this.router.navigate(['/job']);
  }

  onJobTypeChange(jobtype : { id: number; text: string }) {
    
    this.removeAllFilterFromJobType(jobtype);
    this.initialLoadJobStatus();
    this.searchModel.selectedStatus = [];
    this.searchModel.selectedStatus.push(this.searchModel.statuses[0]);
    this.updateSnoozedJobsCheckboxVisibility();
  }

  initialLoadJobStatus() {
    this.searchModel.statuses = [];
    const isAnyJobType = this.searchModel.selectedJobType.some(a => a.text.includes('Any'));
    const isOpenJobType = this.searchModel.selectedJobType.some(a => a.id === JobTypeEnum.OpenJob) 
    const isClosedJobType = this.searchModel.selectedJobType.some(a => a.id === JobTypeEnum.closedJob);
    const isRecurringJobType = this.searchModel.selectedJobType.some(a => a.id === JobTypeEnum.reccurringJob);

    if (isAnyJobType || (isOpenJobType && (isClosedJobType || isRecurringJobType))) {
        this.searchModel.statuses = this.searchModel.openJobStatus
          .concat(this.searchModel.closedJobStatus);
    } else if (isRecurringJobType || (isClosedJobType && isRecurringJobType)) {
        this.searchModel.statuses = this.searchModel.closedJobStatus
          .concat(this.searchModel.openJobStatus.filter(status => status.text !== 'Snoozed'));
    } else if (isOpenJobType) {
        this.searchModel.statuses = [...this.searchModel.openJobStatus];
    } else if (isClosedJobType) {
        this.searchModel.statuses = [...this.searchModel.closedJobStatus];
    } 

    this.searchModel.statuses.sort((f1, f2) => f1.text.length - f2.text.length);

    this.setWorkOrderOption();

    this.searchModel.statuses.unshift({ id: null, text: 'Any' });    

    if (this.searchModel.selectedStatus.length === 0) {
      this.searchModel.selectedStatus.push(this.searchModel.statuses[0]);
    }
  }

  setWorkOrderOption(){
    if (this.searchModel.selectedJobType.some((a) => a.text.includes('Any')) 
      || this.searchModel.selectedJobType.some((a) => a.id == JobTypeEnum.OpenJob)) 
    {
    this.searchModel.statuses.unshift({ id: -1, text: 'Work Orders' });
    }
  }

  removeAllFilterFromJobType(jobtype : { id: number; text: string }) {
    if(jobtype.text == "Any"){
      this.searchModel.selectedJobType = [];
      this.searchModel.selectedJobType.push(jobtype);
    }
    else{
      this.searchModel.selectedJobType = this.searchModel.selectedJobType.filter((x) => !x.text.includes("Any"));
    }
    if (this.searchModel.selectedJobType.length == 0) {
      this.searchModel.selectedJobType = [this.searchModel.jobTypes[0]];
    }
  }

  removeAllFilterFromStatus(status :{ id: number; text: string }) {
    if(status.text == "Any"){
      this.searchModel.selectedStatus = [];
      this.searchModel.selectedStatus.push(status);
    }
    else if(status.text == "Work Orders"){

      let selectedStatus = this.searchModel.selectedStatus.filter(x => x.text.includes("Overdue") 
                                                        || x.text.includes("Scheduled")
                                                        || x.text.includes("Unscheduled")
                                                        || x.text.includes("In Progress")
                                                        || x.text.includes("Pending Invoice")
                                                        || x.text.includes("Pending Schedule")
                                                        || x.text.includes("External / Strata"));
      if(selectedStatus.length > 0){
        selectedStatus.forEach(x => {
          this.searchModel.selectedStatus = this.searchModel.selectedStatus.filter(s => s.id != x.id);
        })
        this.searchModel.selectedStatus = this.searchModel.selectedStatus.filter(s => !s.text.includes("Work Orders"));
        return;
      }

      this.searchModel.selectedStatus = [];
 
      this.searchModel.selectedStatus = this.searchModel.statuses.filter(x => x.text.includes("Work Orders") 
                                                        || x.text.includes("Overdue") 
                                                        || x.text.includes("Scheduled")
                                                        || x.text.includes("Unscheduled")
                                                        || x.text.includes("In Progress")
                                                        || x.text.includes("Pending Invoice")
                                                        || x.text.includes("Pending Schedule")
                                                        || x.text.includes("External / Strata"));
    }
    else{
      this.searchModel.selectedStatus = this.searchModel.selectedStatus.filter((x) => !x.text.includes("Any"));
    }
    if (this.searchModel.selectedStatus.length === 0) {
      this.searchModel.selectedStatus.push(this.searchModel.statuses[0]);
    }
  }

  onStatusChange(status :{ id: number; text: string }) {
    this.removeAllFilterFromStatus(status);
  }
  OnRemoveServiceTypeChip(servType: any): void {
    const index = this.searchModel.serviceTypesChips.indexOf(servType);
    if (index >= 0) {
      this.searchModel.serviceTypesChips.splice(index, 1);
    }
  }
  OnAddServiceTypeChip(event: MatChipInputEvent): void {
    event.chipInput!.clear();
  }

  OnSelectedServiceType(event: MatAutocompleteSelectedEvent): void {
    this.searchModel.serviceTypesChips.push({
      id: event.option.value.primaryJobType?.id,
      text: event.option.value.primaryJobType?.name,
    });
    this.serviceTypeInput.nativeElement.value = '';
    var selectedChip = this.searchModel.serviceTypesChips.filter(
      (e) => e.id == event.option.value.primaryJobType?.id
    );
    if (selectedChip.length > 1) this.OnRemoveServiceTypeChip(selectedChip[0]);
  }

  OnSelectedTradee(event: MatAutocompleteSelectedEvent): void {
    this.searchModel.tradeesChips.push({
      id: event.option.value?.id,
      text: event.option.value?.fullNameDisplay,
    });
    this.tradeeInput.nativeElement.value = '';
    var selectedChip = this.searchModel.tradeesChips.filter(
      (e) => e.id == event.option.value?.id
    );
    if (selectedChip.length > 1) this.OnRemoveTradeeChip(selectedChip[0]);
  }

  OnRemoveTradeeChip(tradeeChip: any): void {
    const index = this.searchModel.tradeesChips.indexOf(tradeeChip);
    if (index >= 0) {
      this.searchModel.tradeesChips.splice(index, 1);
    }
  }

  OnAddTradeeChip(event: any): void {
    event.chipInput!.clear();
  }

  OnSelectedProperty(event: MatAutocompleteSelectedEvent): void {
    this.searchModel.propertyChips.push({
      id: event.option.value?.id,
      text: event.option.value?.address,
    });
    this.propertyInput.nativeElement.value = '';
    var selectedChip = this.searchModel.propertyChips.filter(
      (e) => e.id == event.option.value?.id
    );
    if (selectedChip.length > 1) this.OnRemovePropertyChip(selectedChip[0]);
  }

  OnRemovePropertyChip(propertyChip: any): void {
    const index = this.searchModel.propertyChips.indexOf(propertyChip);
    if (index >= 0) {
      this.searchModel.propertyChips.splice(index, 1);
    }
  }

  OnAddPropertyChip(event: any): void {
    event.chipInput!.clear();
  }

  OnApplySearchCriterias() {
    this.isApply = true;
    this.searchModel.scrolledTop = 0;
    this.requestDto.jobNameOrNumber =
      this.searchModel.selectedJobIdentification;
    this.requestDto.tradeIds = this.removeDuplicate(
      this.searchModel.tradeesChips
    )
      ?.map((s) => s.id)
      .toString()
      .trim();
    this.requestDto.types = this.removeDuplicate(
      this.searchModel.selectedJobType
    )
      ?.map((s) => s.id)
      .toString()
      .trim();
    this.requestDto.jobStatus = this.removeDuplicate(
      this.searchModel.selectedStatus
    )
      ?.map((s) => s.id)
      .toString()
      .trim();

    this.requestDto.urgencyTypeId = this.searchModel.selectedUrgency.id;
    this.requestDto.serviceTypes = this.removeDuplicate(
      this.searchModel.serviceTypesChips
    )
      ?.map((s) => s.id)
      .toString()
      .trim();
    this.requestDto.propertyIds = this.removeDuplicate(
      this.searchModel.propertyChips
    )
      ?.map((s) => s.id)
      .toString()
      .trim();
    this.requestDto.postedFromDate = this.searchModel.posted_Start != null ? new Date(new Date(this.searchModel.posted_Start).setHours(0, 0, 0, 0)).toUTCString():'';
    this.requestDto.postedToDate = this.searchModel.posted_End != null ? new Date(new Date(this.searchModel.posted_End).setHours(23, 59, 59, 0)).toUTCString():'';
    this.requestDto.dueFromDate = this.searchModel.deadLine_Start;
    this.requestDto.dueToDate = this.searchModel.deadLine_end;
    this.requestDto.pageNumber = 1;
    this.requestDto.pageSize = this.searchModel.pageSize;
    this.searchModel.isApply = true;
    this.searchModel.pageNumber = 1;
    this.requestDto.selectedTeamBusinessUserIds = this.searchModel.selectedTeamUsers
      .filter(u => u.businessUserId != this.ORGANIZATION_VIEW_ID)
      .map(u => u.businessUserId).toString();
    this.requestDto.isSnoozedJob = this.searchModel.isSnoozedJob;
    this.requestDto.sortColumn = 'PostedDate';
    this.requestDto.sortDirection = 'DESC';

    this.jobSearchService.getAdvancedSearchData(this.requestDto).subscribe({
      next: (result) => {
        this.jobList = result;
        this.resultEmit(result);
        this.isApply = false;
      },
      error: (error) => {},
    });
  }

  removeDuplicate(a: Array<{ id: number; text: string }>) {
    if (a.length > 1 && a.some((x) => x.text.includes('Any'))) {
      a = a.filter((r) => r.text.includes('Any'));
    }
    return a.filter(function (item, pos, self) {
      return self.indexOf(item) == pos;
    });
  }

  OnReset(deactivatedPropertyInput,snoozedJobsInput) {
    this.SetDefaultValues(deactivatedPropertyInput,snoozedJobsInput);
    this.resultEmit(null);
  }

  getTeamUsers() {
    this.jobSearchService.getSelectedTeam().subscribe({
      next: (res) => {
        this.teamUsers = res;
        this.teamUsers.forEach((u) => u.selected = false);
        this.teamUsers.unshift(this.createOrganizationView());

        if (this.searchModel.selectedTeamUsers.length > 0) {
          this.teamUsers.forEach((u) => {
            this.searchModel.selectedTeamUsers.some((s) => s.businessUserId == u.businessUserId)
              ? u.selected = true
              : u.selected = false;
          });
        }
        
        this.searchModel.selectedTeamUsers = this.teamUsers.filter((u) => u.selected);
      },
    });
  }

  onChangeTeamUser(user: any) {

    user.selected = !user.selected;

    if (this.searchModel.selectedTeamUsers.length == 0 || user.businessUserId == this.ORGANIZATION_VIEW_ID
    ) {
      this.teamUsers.forEach((u) => {
        u.businessUserId == this.ORGANIZATION_VIEW_ID
          ? u.selected = true
          : u.selected = false;
      });
    } else {
      this.teamUsers.find((u) => u.businessUserId == this.ORGANIZATION_VIEW_ID).selected = false;
    }

    this.searchModel.selectedTeamUsers = this.teamUsers.filter((u) => u.selected);
  }

  createOrganizationView() {
    let user = new SelectedTeamResult();
    user.name = 'Organization view';
    user.businessUserId = this.ORGANIZATION_VIEW_ID;
    user.selected = true;
    return user;
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  resultEmit(jobList: any) {
    this.requestDtoEvent.emit(jobList);
  }

  setPostedStartEndDate(){
    this.searchModel.posted_Start = new Date();
    this.searchModel.posted_Start = new Date(this.searchModel.posted_Start.setDate(this.searchModel.posted_Start.getDate() - 60)); //Backdate the posted start date to two months

    this.searchModel.posted_End  = new Date(); //Set current date to posted end date
  }

  updateSnoozedJobsCheckboxVisibility() {  
    const isOpenType = this.searchModel.selectedJobType?.some(type => type.text === 'Open');
    this.snoozedJobsCheckboxVisible = isOpenType;
    
    if(this.searchModel.isApply) {
      this.isSnoozedJob = this.searchModel.isSnoozedJob;
    }

    if(this.searchModel.isApply && !isOpenType) {
      this.searchModel.isSnoozedJob = false
    }

  }
  
}
